var vueApp;

(function($) {
	// https://github.com/monterail/vuelidate
	Vue.use(window.vuelidate.default);

  vueApp = new Vue({
    el: '#app-vue',
    data: {
      values: {}
    },
    components: {
      action: ActionsComponent,
      shops: ShopsComponent,
      ActionPopupComponent: ActionsPopupComponent,
      tooltipComponent: tooltipComponent,
      ShopsComponent: ShopsComponent,
			SwitchComponent: SwitchComponent,
			CafeComponent: CafeComponent,
			ContactsComponent: ContactsComponent,
			mapShops: MapShopsComponent,
			spinner: SpinnerComponent
    }
  });

})(jQuery);
